<template>
  <div class="csx-picker-card">
    <div class="csx-picker-header">
      <span class="csx-picker-header-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m20.59 13.41-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z" />
          <circle cx="7" cy="7" r="1.5" fill="currentColor" stroke="none" />
        </svg>
      </span>
      <span>برندها</span>
    </div>

    <div class="csx-search-wrap">
      <svg class="csx-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
      </svg>
      <input
          ref="searchInput"
          v-model="searchLocal"
          type="text"
          placeholder="جستجوی برندها..."
          class="csx-search-input"
      >
    </div>

    <div class="csx-tree-scroll">
      <div v-if="loading" class="csx-tree-empty">در حال بارگذاری...</div>
      <div v-else-if="!filteredBrands.length" class="csx-tree-empty">
        {{ brands.length ? "نتیجه‌ای یافت نشد" : "برندی وجود ندارد" }}
      </div>

      <div
          v-for="brand in filteredBrands"
          :key="brand.id"
          class="csx-flat-item"
          :class="{ 'is-active': brand.id === selectedId }"
          @click="$emit('select', brand)"
      >
        <div class="csx-flat-item-row">
          <div class="csx-flat-name" v-html="highlight(brand.name)"></div>
          <span v-if="brand.product_count != null" class="csx-flat-count">{{ formatNumber(brand.product_count) }}</span>
        </div>
      </div>
    </div>

    <div v-if="selectedNode" class="csx-preview-box">
      <div class="csx-preview-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        پیش‌نمایش انتخاب فعلی
      </div>
      <div class="csx-preview-name">{{ selectedNode.name }}</div>
      <div class="csx-preview-count">تعداد محصولات: {{ formatNumber(selectedNode.product_count) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandSeoPickerPanel",
  props: {
    brands: { type: Array, default: () => [] },
    selectedId: { type: [Number, String], default: null },
    selectedNode: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { searchLocal: "" };
  },
  computed: {
    filteredBrands() {
      const q = this.searchLocal.trim().toLowerCase();
      const list = q ? this.brands.filter((b) => (b.name || "").toLowerCase().includes(q)) : this.brands;
      return list.slice().sort((a, b) => (a.name || "").localeCompare(b.name || "", "fa"));
    },
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput && this.$refs.searchInput.focus();
    },
    formatNumber(val) {
      if (val === null || val === undefined) return "۰";
      return Number(val).toLocaleString("fa-IR");
    },
    escapeHtml(s) {
      return String(s)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
    },
    escapeRegExp(s) {
      return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    highlight(name) {
      const q = this.searchLocal.trim();
      const nameEsc = this.escapeHtml(String(name || ""));
      if (!q) return nameEsc;
      const rx = new RegExp(this.escapeRegExp(q), "gi");
      return nameEsc.replace(rx, (m) => `<mark class="csx-hl">${m}</mark>`);
    },
  },
};
</script>

<style scoped>
.csx-picker-card {
  background: #0d1729;
  border: 1px solid #273753;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.16);
}
.csx-picker-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #f8fafc;
}
.csx-picker-header-icon {
  width: 18px;
  height: 18px;
  color: #b04cff;
}
.csx-picker-header-icon svg {
  width: 100%;
  height: 100%;
}

.csx-search-wrap {
  position: relative;
}
.csx-search-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #6e7b94;
  pointer-events: none;
}
.csx-search-input {
  width: 100%;
  height: 42px;
  background: #111d32;
  border: 1px solid #273753;
  border-radius: 10px;
  padding: 0 38px 0 12px;
  color: #f8fafc;
  font-size: 12.5px;
}
.csx-search-input::placeholder {
  color: #6e7b94;
}
.csx-search-input:hover {
  border-color: #384c70;
}
.csx-search-input:focus {
  outline: none;
  border-color: #7557ff;
  box-shadow: 0 0 0 3px rgba(117, 87, 255, 0.14);
}

.csx-tree-scroll {
  max-height: 420px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.csx-tree-empty {
  color: #6e7b94;
  font-size: 12px;
  text-align: center;
  padding: 24px 8px;
}

.csx-flat-item {
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid transparent;
}
.csx-flat-item:hover {
  background: #162238;
}
.csx-flat-item.is-active {
  background: rgba(117, 87, 255, 0.18);
  border-color: #7557ff;
}
.csx-flat-item-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.csx-flat-name {
  font-size: 12.5px;
  color: #f8fafc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.csx-flat-count {
  flex-shrink: 0;
  background: #1c2941;
  color: #a8b2c7;
  font-size: 10px;
  line-height: 1;
  padding: 3px 7px;
  border-radius: 999px;
}
.csx-flat-item.is-active .csx-flat-count {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.csx-preview-box {
  margin-top: 4px;
  padding-top: 14px;
  border-top: 1px solid #273753;
}
.csx-preview-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 700;
  color: #a8b2c7;
  margin-bottom: 8px;
}
.csx-preview-title svg {
  width: 14px;
  height: 14px;
  color: #4e98f7;
}
.csx-preview-name {
  font-size: 13.5px;
  font-weight: 700;
  color: #f8fafc;
  margin-bottom: 6px;
}
.csx-preview-count {
  font-size: 11px;
  color: #35c88a;
}
</style>

<style>
.csx-hl {
  background: linear-gradient(90deg, rgba(117, 87, 255, 0.35), rgba(176, 76, 255, 0.35));
  color: #ffffff;
  padding: 0 0.15rem;
  border-radius: 0.25rem;
}
</style>
